import { useContext, useRef, useState, CSSProperties } from "react"
import { DataContext } from "../data/DataContext"
import { IconHappy } from '../img'
import { CheckBox } from '../components'

const StepFinish = () => {
    const { vidaCR, changeHandler2 } = useContext(DataContext);
    let inpuReqtRef = useRef<HTMLInputElement>(null);

    const centerCss: CSSProperties = {
        display: 'flex',
        justifyContent: 'center'
    }

    const download = (e: any) => {
        e.preventDefault();
        vidaCR.downloadPolicy(vidaCR.polizaid)
    }

    const finish = (e: any) => {
        e.preventDefault();
        vidaCR.finish();
    }

    return <>
        <label className="lbl-title title-1">
            ¡Transacción exitosa!
        </label>
        <div className="lbl-input-vida-cr mb-20">
            Muchas gracias por confiar en Seguros LAFISE, la <br /> aseguradora digital regional.
        </div>
        <div className="lbl-input-vida-cr card-vida-cr-finish" >
            <div className="mt-20" style={centerCss}>
                Tú número de solicitud es: <span style={{ color: '#00a68e', marginLeft: '5px' }}> <strong>{vidaCR.polizaid}</strong></span>
            </div>
            <div className="mt-30" style={centerCss}>
                <IconHappy />
            </div>
            <p>
                En breve recibirás en tu correo electrónico  <br /> el recibo de compra.
            </p>
            <p>
                Nuestros ejecutivos se contactarán contigo  <br /> para confirmar datos y coordinar la entrega  <br /> de los documentos del seguro
            </p>
            <div className="mt-30 mb-30" >
                <button className='btn-vida-cr next' onClick={download}>   Descargar<br />  condiciones </button>
            </div>
        </div>
        <CheckBox
            key={'acceptTermsFinish'}
            field="acceptTermsFinish"
            label="He leído y comprendido las condiciones generales de la póliza"
            onChange={changeHandler2}
            onClickLabel={() => { }}
            value={vidaCR.acceptTermsFinish}
        />

        <div className="mt-30 mb-30" style={{ display: 'flex', justifyContent: 'flex-end' }} >
            <button className='btn-vida-cr next' onClick={finish}>   Finalizar </button>
        </div>
    </>
}

export { StepFinish }